import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { Button, Icon, AppBar, Toolbar } from '@material-ui/core';
import { invitesRef, eventsRef } from '../../firebase';

import mayBeIcon from '../../images/information.png';
import yesIcon from '../../images/checked.png';
import noIcon from '../../images/error.png';
import dollarIcon from '../../images/dollar-symbol.png';

const styles = theme => ({
    title: {
        paddingLeft: '80px',
        paddingRight: '80px',
        paddingTop: '35px',
    },
    card: {
        marginTop: "10px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#fff"
    },
    cardHover: {
        marginTop: "30px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#AAA"
    },
    cardAvatar: {
        maxWidth: "130px",
        maxHeight: "130px",
        borderRadius: "50%",
        overflow: "hidden",
        boxShadow:
            "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },

    textAlign: {
        textAlign: "center"
    },
    cardSubtitle: {
        color: "#999",
        fontSize: "1em",
        textTransform: "uppercase",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardTitle: {
        fontSize: "1.3em",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardDescription: {
        padding: "5px 10px",
    },
    cardActions: {
        height: "auto",
        display: "inline"
    }
});

class EventDetails extends Component {
    constructor(props) {
        super(props);
        const { id } = props.match.params;
        this.state = {
            loading: true,
            open: false,
            deleteStatus: false,
            deleteError: false,
            redirect: false,
            updateRequest: false,
            bgColor: '#FFF',
            id,
            name: '',
            date: '',
            description: '',
            location: '',
            kids: '',
            images: [],
        };
    }

    componentDidMount() {
        eventsRef.doc(this.state.id).get()
        .then((snapshot) => {
            const {
                name,
                date,
                description,
                kids,
                location,
                images,
            } = snapshot.data();
            
            invitesRef.where('eventId', '==', this.state.id).get()
            .then((querySnapshot) => {
                var guests = [];

                querySnapshot.forEach((snapshot) => {
                    guests.push(snapshot.data());
                });

                this.setState( {
                    name,
                    date,
                    description,
                    kids,
                    location,
                    guests,
                    images,
                    loading: false,
                })
            });
        });
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };


    eventDetail = (id) => {
        this.setState({
            eventUrl: '/events/update/' + id,
            eventRedirect: true,
        })
    }

    render() {
        const { classes } = this.props;

        if (this.state.eventRedirect) {
            return(
                <Redirect to={this.state.eventUrl} />
            )
        }
        
        if (this.state.loading) {
            return (
                <h2>Loading...</h2>
            );
        }
        
        if (this.state.updateRequest) {
            var updateId = "/events/update/" + this.state.id;
            return (
                <Redirect to={updateId} />
            );
        }

        var guestsSection = [];

        this.state.guests.forEach((guest, index) => {

            guestsSection[index] =
            <Card style={{ paddingBottom: '20px' }} className={classes.card} >
                <CardContent>
                    <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid item xs={10} sm={10} md={9} lg={9} xl={4}>
                            <Typography variant='title' className={classes.cardDescription}>
                                {guest.email}
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sm={2} md={3} lg={3} xl={4}>
                            <Typography component="p" className={classes.cardDescription}>
                                {guest.amount > 0 && <img src={dollarIcon} height={30} width={30} alt='DONATED' />}
                                
                                {guest.rsvpStatus === 0 && <img src={yesIcon} height={30} width={30} alt='YES'/>}
                                {guest.rsvpStatus === 1 && <img src={noIcon} height={30} width={30} alt='NO' />}
                                {(guest.rsvpStatus === 2 || guest.rsvpStatus === undefined) && <img src={mayBeIcon} height={30} width={30} alt='Maybe' />}
                            </Typography>

                        </Grid>
                    </Grid>
                </CardContent>
            </Card>;
        });

        const imageSection = (
            this.state.images.map(value => (
                <Grid style={{ textAlign: 'center' }} item xs={12} sm={6} md={4} lg={3} xl={3}>
                    <img style={{ height: '200px', width: '80%' }} alt='EVENT-IMG' src={value.url} />
                </Grid>
            ))
        )

        return (
            <div style={{ padding:'40px' }}>
                <Card style={{ background: this.state.bgColor }} className={classes.card} >
                    <CardContent>
                        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid spacing={0} container item xs={12} sm={8} md={9} lg={9} xl={9} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <Typography variant='title' className={classes.cardDescription}>
                                    {this.state.name}
                                    </Typography>
                                    <Typography component="p" className={classes.cardDescription}>
                                    {this.state.date}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <Typography component="p" className={classes.cardDescription}>
                                    {this.state.description}
                                    </Typography>
                                    <Typography component="p" className={classes.cardDescription}>
                                    {this.state.location}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={3} md={1} lg={1} xl={1}>
                                {this.props.location.bg === '#FFF' &&
                                    <Button onClick={() =>{ this.setState({ updateRequest: true }) }} variant="fab" color="secondary" aria-label="edit" className={classes.button}>
                                        <Icon>edit_icon</Icon>
                                    </Button>
                                }
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card >
                
                {imageSection}

                <AppBar position="static">
                    <Toolbar> GUESTS</Toolbar>
                </AppBar>
                {guestsSection}
            </div>
        );
    }
}

EventDetails.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EventDetails);



// WEBPACK FOOTER //
// ./src/components/Events/EventDetails.js